export default __webpack_public_path__ + "static/media/coverwallet-background-desktop.c5b6de35.png";